/**
 * Live "Open now / Closed" pill on branch cards, worked out in the browser so full-page caching never shows a stale status.
 * The pill stays hidden whenever today's hours can't be read with confidence.
 */
const OpeningStatus = require('./opening-status');

module.exports = function () {
    document.querySelectorAll('[data-opening-times]').forEach(function (branch) {
        const pill = branch.querySelector('[data-opening-status]');

        if (!pill)
            return;

        let status = null;

        try {
            status = OpeningStatus.openingStatus(JSON.parse(branch.dataset.openingTimes));
        } catch (e) {
            return;
        }

        if (!status)
            return;

        // Keep the closed pill short; the hours list below says when it next opens
        pill.textContent = status.open ? status.text : 'Closed now';
        pill.classList.toggle('open', status.open);
        pill.classList.remove('d-none');
    });
};
